"use strict";

exports.__esModule = true;
exports.SKINS = exports.SIZES = void 0;
var SKINS = exports.SKINS = {
  standard: 'standard',
  standardFilled: 'standardFilled',
  light: 'light',
  lightFilled: 'lightFilled',
  dark: 'dark',
  transparent: 'transparent'
};
var SIZES = exports.SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
//# sourceMappingURL=constants.js.map